<div class="c-menu-mobile">
  <input
    type="checkbox"
    class="openSidebarMenu"
    id="openSidebarMenu"
    [checked]="isToggled" />
  <label
    #sidebarIconToggle
    class="sidebarIconToggle"
    id="burger_mobile"
    (click)="toggleMenu()">
    <div class="spinner diagonal part-1"></div>
    <div class="spinner horizontal"></div>
    <div class="spinner diagonal part-2"></div>
  </label>
  <div
    #sidebarMenu
    id="sidebarMenu"
    class="sidebarMenu u-shadow"
    [class.active]="isToggled">
    <div class="row u-p-x-only">
      <div class="col sidebarMenu__wrapper">
        <ul class="sidebarMenu__list">
          <li class="u-b-divider">
            <a
              class="sidebarMenu__link"
              id="list-main-item-mobile"
              routerLink="{{ routeNameConstants.ROOT }}">
              {{ localizationConstants.HEADER_HOME | translate }}
              <mat-icon
                class="sidebarMenu__link-icon"
                svgIcon="chevronRight"></mat-icon>
            </a>
          </li>
          <li class="u-b-divider">
            <a
              class="sidebarMenu__link"
              id="list-main-item-mobile"
              routerLink="{{ routeNameConstants.TOOLS }}">
              {{ localizationConstants.HEADER_TOOLS | translate }}
              <mat-icon
                class="sidebarMenu__link-icon"
                svgIcon="chevronRight"></mat-icon>
            </a>
          </li>
          <li
            class="u-b-divider"
            *ngIf="authService.user?.allowTechCover">
            <a
              class="sidebarMenu__link"
              id="list-main-item-mobile"
              routerLink="{{ routeNameConstants.TECH_COVER }}">
              {{ localizationConstants.HEADER_MY_SOFTWARE | translate }}
              <mat-icon
                class="sidebarMenu__link-icon"
                svgIcon="chevronRight"></mat-icon>
            </a>
          </li>
          <li class="u-b-divider">
            <a
              class="sidebarMenu__link"
              id="list-main-item-mobile"
              routerLink="{{ routeNameConstants.TOOL_LOCATION }}">
              {{ localizationConstants.HEADER_LOCATIONS | translate }}
              <mat-icon
                class="sidebarMenu__link-icon"
                svgIcon="chevronRight"></mat-icon>
            </a>
          </li>
          <li
            class="u-b-divider"
            *ngIf="authService.user?.allowContracts">
            <a
              routerLink="{{ routeNameConstants.CONTRACTS }}"
              class="sidebarMenu__link"
              id="list-main-d-mobile"
              routerLink="{{ routeNameConstants.CONTRACTS }}">
              {{ localizationConstants.HEADER_CONTRACTS | translate }}
              <mat-icon
                class="sidebarMenu__link-icon"
                svgIcon="chevronRight"></mat-icon>
            </a>
          </li>
          <li
            class="u-b-divider"
            *ngIf="authService.user?.allowFieldService">
            <a
              routerLink="{{ routeNameConstants.FIELD_SERVICE }}"
              class="sidebarMenu__link"
              id="list-main-d-mobile"
              routerLink="{{ routeNameConstants.FIELD_SERVICE }}">
              {{ localizationConstants.HEADER_FIELD_SERVICE | translate }}
              <mat-icon
                class="sidebarMenu__link-icon"
                svgIcon="chevronRight"></mat-icon>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div
    [class.active]="isToggled"
    class="menu-mobile__background-overlay"></div>
</div>
